export const themePresets = [
  {
    id: "aurora",
    name: "Aurora",
    accent: "#7c3aed",
    accentSoft: "#06b6d4",
    glow: "rgba(124, 58, 237, 0.28)",
  },
  {
    id: "sunset",
    name: "Sunset",
    accent: "#f97316",
    accentSoft: "#ef4444",
    glow: "rgba(249, 115, 22, 0.28)",
  },
  {
    id: "ocean",
    name: "Ocean",
    accent: "#0f766e",
    accentSoft: "#38bdf8",
    glow: "rgba(15, 118, 110, 0.3)",
  },
  {
    id: "forest",
    name: "Forest",
    accent: "#15803d",
    accentSoft: "#84cc16",
    glow: "rgba(21, 128, 61, 0.28)",
  },
  {
    id: "ruby",
    name: "Ruby",
    accent: "#be123c",
    accentSoft: "#fb7185",
    glow: "rgba(190, 18, 60, 0.28)",
  },
  {
    id: "midnight",
    name: "Midnight",
    accent: "#4338ca",
    accentSoft: "#8b5cf6",
    glow: "rgba(67, 56, 202, 0.3)",
  },
  {
    id: "gold",
    name: "Gold",
    accent: "#ca8a04",
    accentSoft: "#f59e0b",
    glow: "rgba(202, 138, 4, 0.28)",
  },
  {
    id: "rose",
    name: "Rose",
    accent: "#db2777",
    accentSoft: "#fb7185",
    glow: "rgba(219, 39, 119, 0.28)",
  },
];

export const designTemplates = [
  {
    id: "glass",
    name: "Glass",
    description: "Layered translucent panels with soft glow.",
  },
  {
    id: "single",
    name: "Single Page",
    description: "One continuous portfolio page with article-style sections.",
  },
  {
    id: "premium",
    name: "Premium",
    description: "Wide luxury layout with stronger imagery and polished cards.",
  },
];

export const defaultThemePreference = {
  mode: "dark",
  templateId: "glass",
  themeId: "aurora",
  accent: "#7c3aed",
  accentSoft: "#06b6d4",
  glow: "rgba(124, 58, 237, 0.28)",
};
